import PaymentTypes from '@/models/PaymentTypes';
import mpiHelper from '@/helpers/mpiHelper';
import { logException } from '@/helpers/cieloLogger';

function formatDateToDDMMYYYY(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export default {
    /**
     * Mapeia os dados do pedido
     * @param {Object} rootState Estado global do módulo Vuex da aplicação
	 * @param {Object} rootGetters Métodos computados do módulo Vuex da aplicação
     */
    mapOrderData(rootState, rootGetters) {
        mpiHelper.addMpiField('bpmpi_ordernumber', rootState.preorder.OrderNumber);
        mpiHelper.addMpiField('bpmpi_currency', '986'); // 986 - BRL
        mpiHelper.addMpiField('bpmpi_totalamount', Math.round(rootGetters['payment/getTotalPrice']*100)); // valor com centavos
        mpiHelper.addMpiField('bpmpi_installments', rootState.payment.NumberOfInstallments);
        mpiHelper.addMpiField('bpmpi_paymentmethod', parsePaymentType(rootState.payment));
        mpiHelper.addMpiField('bpmpi_cardnumber', rootState.cardPayment.CardNumber);
        mpiHelper.addMpiField('bpmpi_cardexpirationmonth', rootState.cardPayment.Expiration.Month);
        mpiHelper.addMpiField('bpmpi_cardexpirationyear', rootState.cardPayment.Expiration.Year);
        // mpiHelper.addMpiField('bpmpi_cardalias', '2021');
        // mpiHelper.addMpiField('bpmpi_default_card', '2021');
    },

    /**
     * Mapeia as características do pedido
     * @param {*} rootState Estado global do módulo Vuex da aplicação
     */
    mapOrderDetails(rootState, rootGetters) {
        let isRecurringPayment = rootGetters['recurrentPayment/isRecurringPayment'];

        if (isRecurringPayment) {

            // let endDate = rootGetters['recurrentPayment/getEndDate'] || '2050-01-16';
            // mpiHelper.addMpiField('bpmpi_recurring_enddate', endDate);

            let interval = rootState.recurrentPayment.Interval || '0';
            let frequencyMap = {
                '0': 1,  // mensalmente
                '1': 2,  // bimestralmente
                '2': 3,  // trimestralmente
                '3': 6,  // semestralmente
                '4': 12  // anualmente
            };
            let frequency = frequencyMap[interval];
            mpiHelper.addMpiField('bpmpi_recurring_frequency', frequency);

            let occurrenceMap = {
                '0': '06',  // mensalmente
                '1': '07',  // bimestralmente
                '2': '08',  // trimestralmente
                '3': '10',  // semestral
                '4': '11'   // anualmente
            };
            let occurrence = occurrenceMap[interval];
            mpiHelper.addMpiField('bpmpi_recurring_occurrence', occurrence);

            let originalPurchaseDate = formatDateToDDMMYYYY(new Date());
            mpiHelper.addMpiField('bpmpi_recurring_originalpurchasedate', originalPurchaseDate);

            mpiHelper.addMpiField('bpmpi_order_recurrence', true);

            let recurringType = 1;
            mpiHelper.addMpiField('bpmpi_recurring_type', recurringType);

            mpiHelper.addMpiField('bpmpi_recurring_validationIndicator', null || 'undefined');

            // Comentado: Valor máximo acordado pelo titular do cartão
            // mpiHelper.addMpiField('bpmpi_recurring_maximumAmount', '');

            // Comentado: Número total de pagamentos durante a assinatura recorrente
            // mpiHelper.addMpiField('bpmpi_recurring_numberOfPayments', '');

            let preOrderId = rootState.preorder.Id;
            mpiHelper.addMpiField('bpmpi_recurring_referenceNumber', preOrderId);

            let amountType = 1;
            mpiHelper.addMpiField('bpmpi_recurring_amountType', amountType);

            mpiHelper.addMpiField('bpmpi_order_recurrence', false);

            mpiHelper.addMpiField('bpmpi_recurring_validationIndicator', null);
        }
        // mpiHelper.addMpiField('bpmpi_recurring_enddate', '');
        // mpiHelper.addMpiField('bpmpi_recurring_frequency', '');
        // mpiHelper.addMpiField('bpmpi_recurring_originalpurchasedate', '');
        // mpiHelper.addMpiField('bpmpi_order_recurrence	', '');

        /**
         * Iremos forçar o productCode PHY
         */

        mpiHelper.addMpiField('bpmpi_order_productcode', 'PHY');
        // mpiHelper.addMpiField('bpmpi_order_countlast24hours', '');
        // mpiHelper.addMpiField('bpmpi_order_countlast6months', '');
        // mpiHelper.addMpiField('bpmpi_order_countlast1year', '');
        // mpiHelper.addMpiField('bpmpi_order_cardattemptslast24hours', '');
        // mpiHelper.addMpiField('bpmpi_order_marketingoptin', '');
        // mpiHelper.addMpiField('bpmpi_order_marketingsource', '');
        // mpiHelper.addMpiField('bpmpi_transaction_mode', '');
        // mpiHelper.addMpiField('bpmpi_merchant_url', 'http://www.loja.com.br');
    },

    mapBillingAddress(rootState) {
        if (!rootState.billingAddress.SameAsShippingAddress) {
            // mpiHelper.addMpiField('bpmpi_billto_customerid', 'http://www.loja.com.br');
            // mpiHelper.addMpiField('bpmpi_billto_contactname', 'http://www.loja.com.br');
            mpiHelper.addMpiField('bpmpi_billto_phonenumber', rootState.customer.Phone);
            mpiHelper.addMpiField('bpmpi_billto_email', rootState.customer.Email);
            mpiHelper.addMpiField('bpmpi_shipto_street1', rootState.billingAddress.Street);
            mpiHelper.addMpiField('bpmpi_shipto_street2', rootState.billingAddress.Complement);
            mpiHelper.addMpiField('bpmpi_shipto_city', rootState.billingAddress.City);
            mpiHelper.addMpiField('bpmpi_shipto_state', rootState.billingAddress.State);
            mpiHelper.addMpiField('bpmpi_shipto_zipcode', rootState.billingAddress.ZipCode);
            // mpiHelper.addMpiField('bpmpi_billto_country', 'http://www.loja.com.br');
        }
    },

    mapShippingAddress(rootState) {
        mpiHelper.addMpiField('bpmpi_shipto_sameasbillto', rootState.billingAddress.SameAsShippingAddress);
        // mpiHelper.addMpiField("bpmpi_shipto_addressee", "http://www.loja.com.br");
        mpiHelper.addMpiField('bpmpi_shipto_phonenumber', rootState.customer.Phone);
        mpiHelper.addMpiField('bpmpi_shipto_email', rootState.customer.Email);
        mpiHelper.addMpiField('bpmpi_shipto_street1', rootState.shippingAddress.Street);
        mpiHelper.addMpiField('bpmpi_shipto_street2', rootState.shippingAddress.Complement);
        mpiHelper.addMpiField('bpmpi_shipto_city', rootState.shippingAddress.City);
        mpiHelper.addMpiField('bpmpi_shipto_state', rootState.shippingAddress.State);
        mpiHelper.addMpiField('bpmpi_shipto_zipcode', rootState.shippingAddress.ZipCode);
        mpiHelper.addMpiField('bpmpi_shipto_country', 'BR'); //TODO: quando tiver o estrangeiro colocar o pais correto do pagador
        // mpiHelper.addMpiField("bpmpi_shipTo_shippingmethod", '');
        // mpiHelper.addMpiField("bpmpi_shipto_firstusagedate", '');
    },

    mapCartItems(rootState) {
        if (rootState.cart.Items.length > 0) {
            rootState.cart.Items.forEach((item, index) => {
                mpiHelper.addMpiField(`bpmpi_cart_${index}_description`, item.Description);
                mpiHelper.addMpiField(`bpmpi_cart_${index}_name`, item.Name);
                mpiHelper.addMpiField(`bpmpi_cart_${index}_sku`, item.Sku);
                mpiHelper.addMpiField(`bpmpi_cart_${index}_quantity`, item.Quantity);
                mpiHelper.addMpiField(`bpmpi_cart_${index}_unitprice`, item.UnitPrice);
            });
        }
    },

    mapUserData(rootState) {
        // mpiHelper.addMpiField('bpmpi_useraccount_guest', '');
        // mpiHelper.addMpiField('bpmpi_useraccount_createddate', '');
        // mpiHelper.addMpiField('bpmpi_useraccount_changeddate', '');
        // mpiHelper.addMpiField('bpmpi_useraccount_passwordchangeddate', '');
        // mpiHelper.addMpiField('bpmpi_useraccount_authenticationmethod', '');
        // mpiHelper.addMpiField('bpmpi_useraccount_authenticationprotocol', '');
        // mpiHelper.addMpiField('bpmpi_useraccount_authenticationtimestamp', '');
        // mpiHelper.addMpiField('bpmpi_merchant_newcustomer', '');
    },

    mapDeviceData: async function(rootState) {
        const getUserIP = async () => {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                return data.ip;
            } catch (error) {
                logException(error);
                return null;
            }
        };

        const userIP = await getUserIP();
        mpiHelper.addMpiField('bpmpi_device_ipaddress', userIP);
        mpiHelper.addMpiField('bpmpi_device_1_fingerprint', rootState.antifraud.BrowserFingerPrint);
        mpiHelper.addMpiField('bpmpi_device_1_provider', rootState.antifraud.BrowserIdentifier);
        mpiHelper.addMpiField('bpmpi_device_channel', 'Browser');
    },

    mapEnrollmentData(){
        mpiHelper.addMpiField('bpmpi_challenge_window_size', '250x400');
    }
};

function parsePaymentType(payment) {
    if (payment.PaymentType == PaymentTypes.CREDIT_CARD)
        return 'Credit';
    else if(payment.PaymentType == PaymentTypes.DEBIT_CARD)
        return 'Debit';

    return '';
}
